import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'idle-Confirmation-dialog',
    templateUrl: './idle-dialog.component.html',
    styleUrls: ['./idle-dialog.component.scss'],
    standalone: false
})
export class IdleDialogComponent implements OnInit, OnDestroy {
    public title: string;
    public timeoutWarning : number;
    idleState: string;
    private countdownInterval: any;
    public onContinueCallback: () => void;

    constructor(
        public dialogRef: MatDialogRef<IdleDialogComponent>
    ) {

    }
    ngOnInit(): void {
        this.idleState = this.timeoutWarning.toString();
        let seconds: number = this.timeoutWarning;
        this.countdownInterval = setInterval(() => {
            seconds--;
            this.idleState = `${seconds}`;
            if (seconds <= 0) {
                this.dialogRef.close('logout');
            }
        }, 1000);
    }

    ngOnDestroy(): void {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    onContinue(): void {
        // Call the callback immediately to reset timer before closing dialog
        if (this.onContinueCallback) {
            this.onContinueCallback();
        }
        this.dialogRef.close('stay');
    }
}
